import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { loadableReady } from '@loadable/component';
import { HelmetProvider } from 'react-helmet-async';

import apolloWrapper from '@hoc/apolloWrapper';
import {
  I18NProvider,
  getClientLocale,
} from '@utils/i18n';
import { AppContext } from '@contexts/AppContext';

import BaseApp from './BaseApp';

const ApolloApp = apolloWrapper(BaseApp);

loadableReady(() => {
  const isWebcache = window.location.hostname === 'webcache.googleusercontent.com';
  if (isWebcache) {
    // Disable JS at webcache pages, because it's not compatible with React Router.
    return;
  }

  const root = document.getElementById('app');
  const { lang, routerBasename } = getClientLocale();

  if (root) {
    setTimeout(
      () => hydrateRoot(
        root,
        <AppContext.Provider value={window.__APP_CONTEXT__}>
            <HelmetProvider>
              <BrowserRouter basename={routerBasename}>
                <I18NProvider lang={lang}>
                  {
                    () => <ApolloApp />
                  }
                </I18NProvider>
              </BrowserRouter>
            </HelmetProvider>
          </AppContext.Provider>,
      ),
      0,
    );
  }
});

if (module.hot) {
  module.hot.accept();
}
